exports.onRouteUpdate = require('./gatsby/browser/onRouteUpdate').onRouteUpdate;
exports.shouldUpdateScroll = require('./gatsby/browser/shouldUpdateScroll').shouldUpdateScroll;
